/*
 * 用户账号信息
 */

import store from '@/store'
import util from './utils'

export function formatUserInfo(obj) {
    let custom = obj.custom || ''
    try {
        custom = JSON.parse(custom)
    } catch (e) {
        custom = {
            data: custom,
        }
    }
    let result = Object.assign(obj, {
        account: obj.account,
        nick: obj.nick || '',
        // avatar: obj.avatar || config.defaultUserIcon,
        avatar: obj.avatar,
        birth: obj.birth || '',
        email: obj.email || '',
        tel: obj.tel || '',
        gender: obj.gender || '',
        sign: obj.sign || '',
        custom,
        createTime: obj.createTime || (new Date()).getTime(),
        updateTime: obj.updateTime || (new Date()).getTime(),
    })

    return result
}

export function onMyInfo(obj) {
    obj = util.mergeObject(store.state.chat.myInfo, obj)
    let myInfo = formatUserInfo(obj)
    store.commit('chat/updateMyInfo', myInfo)
}

export function onUserInfo(users) {
    if (!Array.isArray(users)) {
        users = [users]
    }
    users = users.map(formatUserInfo)
    store.commit('chat/updateUserInfo', users)
}
